module.exports = __webpack_public_path__ + "img/iconProvince1.0e8b5c18.svg";